// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__2owkQ","legacyBtn":"MutateMid_legacyBtn__37-ur"};